import type { ModalConfig, RequestView, UserRef } from '../types.js';
import { ReturnRequestModal } from './modals/ReturnRequestModal.js';
import { ReopenRequestModal } from './modals/ReopenRequestModal.js';
import { CloseRequestModal } from './modals/CloseRequestModal.js';
import { PickWinnerModal } from './modals/PickWinnerModal.js';
import { SuccessRequestModal } from './modals/SuccessRequestModal.js';
import { RefuseRequestModal } from './modals/RefuseRequestModal.js';
import { CannotTransportModal } from './modals/CannotTransportModal.js';

export function RequestDrawerModalHost({
  modal,
  request,
  me,
}: {
  modal: ModalConfig | null;
  request: RequestView;
  me: UserRef;
}) {
  if (!modal || modal.requestId !== request.id) return null;
  if (modal.type === 'return') {
    return <ReturnRequestModal request={request} me={me} />;
  }
  if (modal.type === 'reopen') {
    return <ReopenRequestModal request={request} me={me} />;
  }
  if (modal.type === 'close') {
    return <CloseRequestModal request={request} me={me} />;
  }
  if (modal.type === 'pickWinner') {
    return <PickWinnerModal request={request} me={me} />;
  }
  if (modal.type === 'success') {
    return <SuccessRequestModal request={request} me={me} />;
  }
  if (modal.type === 'refuse') {
    return <RefuseRequestModal request={request} me={me} />;
  }
  if (modal.type === 'cannotTransport') {
    return <CannotTransportModal request={request} me={me} />;
  }
  // Defensive — modal.type is exhausted by the union, but TS demands a path.
  return null;
}
